<template>
	<div class="firstView">
		<div class="box1 mainCont" v-if="false">
			<h3>企业核心价值观</h3>
			<p class="name">Core values</p>
			<ul>
				<li>
					<img src="../../../../static//about/qitem1-img1.png" alt="1" class="img">
					<h4>客户第一</h4>
					<p>来自客户对我们的信赖以及我们对行业的热爱来自客户对我们的信赖以及我</p>
				</li>
				<li>
					<img src="../../../../static//about/qitem1-img2.png" alt="1" class="img">
					<h4>团队合作</h4>
					<p>客户第一客户第一客户第一客户第一客户第一客户第一客户第一</p>
				</li>
				<li>
					<img src="../../../../static//about/qitem1-img3.png" alt="1" class="img">
					<h4>诚信守诺</h4>
					<p>来自客户对我们的信赖以及我们对行业的热爱来自客户对我们的信赖以及我</p>
				</li>
			</ul>
			<ul class="flex">
				<li>
					<img src="../../../../static//about/qitem1-img4.png" alt="1" class="img">
					<h4>工匠精神</h4>
					<p>来自客户对我们的信赖以及我们对行业的热爱来自客户对我们的信赖以及我</p>
				</li>
				<li>
					<img src="../../../../static//about/qitem1-img5.png" alt="1" class="img">
					<h4>拥抱变化</h4>
					<p>客户第一客户第一客户第一客户第一客户第一客户第一客户第一</p>
				</li>
			</ul>
		</div>
		<div class="box2" v-if="false">
			<div class="mainCont">
				<h3>服务价值</h3>
				<p class="name">service value </p>
				<div class="cont">
					<div class="lfet">
						<img class="img1" src="../../../../static//about/qItem2-img1.png" alt="">
						<img class="img2" src="../../../../static//about/qItem2-img2.png" alt="">
					</div>
					<div class="right">
						<div class="item">
							<img class="img" src="../../../../static//about/qItem2-img3.png" alt="">
							<div class="txt">
								<h5>便捷</h5>
								<p>"便”，用户非常方便找我们下单，对接到最合适服务人员;“捷”，下单快、响应快、上门快解决问题快</p>
							</div>
						</div>
						<div class="item left">
							<img class="img" src="../../../../static//about/qItem2-img3.png" alt="">
							<div class="txt">
								<h5>专业</h5>
								<p>"系统化、标准化、技术全面、精透，引领家庭维保技术发展。</p>
							</div>
						</div>
						<div class="item left">
							<img class="img" src="../../../../static//about/qItem2-img3.png" alt="">
							<div class="txt">
								<h5>安心</h5>
								<p>安心、放心、舒心</p>
							</div>
						</div>
						<div class="item">
							<img class="img" src="../../../../static//about/qItem2-img3.png" alt="">
							<div class="txt">
								<h5>超值</h5>
								<p>解决用户实际需求，维保性价比高，享受増值服务</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="box3 mainCont" v-if="false">
			<h3>服务理念</h3>
			<p class="name">service idea</p>
			<ul>
				<li>
					<div class="icon"><i class="iconfont icon-weibiaoti"></i></div>
					<h5>守诺</h5>
					<p>按章承诺，有诺比履行</p>
				</li>
				<li>
					<div class="icon"><i class="iconfont icon-a-bianzu23"></i></div>
					<h5>透明</h5>
					<p>出示价格标准，按标准收费，服务过程透明</p>
				</li>
				<li>
					<div class="icon"><i class="iconfont icon-shouye_zhunshi"></i></div>
					<h5>准时</h5>
					<p>按预定或沟通达成一致的时间准时上门服务</p>
				</li>
				<li>
					<div class="icon"><i class="iconfont icon-qinjinshejiaocanyu"></i></div>
					<h5>亲近</h5>
					<p>让用户感觉亲切、贴心热情周到</p>
				</li>
			</ul>
		</div>

		<div class="dex mainCont" v-html="content"></div>
	</div>
</template>

<script>
	
import {getArtice} from '@/api/api'
	import {formatRichText} from "@/utils/utils"
	export default {
		name: 'firstView',
		components: {},
		data() {
			return {
				articeObj:{},
				content:'',
			};
		},
		mounted() {
			console.log('6661111')
			this.getArtice();
		},
		methods: {
			// 企业简介
			getArtice(){
				getArtice({type:'5'}).then(res => {
					this.articeObj = res.data;
					this.content = formatRichText(res.data.content)
				})
			},
		},
	};
</script>

<style lang="scss" scoped>
	.firstView {padding-top: 50px;
		.box1 {
			h3{color: #1F263F;font-size: 36px;font-weight: bold;text-align: center;margin-bottom: 10px;}
			p.name{text-align: center;color: #A4A9B7;font-size: 18px;text-transform: uppercase;margin-bottom: 48px;}
			ul{display: flex;align-items: center;flex-wrap: wrap;justify-content: space-between;
				&.flex{justify-content: space-around;margin-top: 40px;padding: 0 180px 80px;}
				li{width: 373px;height: 298px;background: #FFFFFF;border-radius: 8px;border: 1px solid #EDEEF1;padding: 50px;text-align: center;
					.img{width: 64px;vertical-align: top;display: inline-block;}
					h4{color: #1F263F;font-size: 20px;font-weight: bold;margin-top: 40px;}
					p{color: #AAB4BD;font-size: 14px;text-align: center;line-height: 22px;margin-top: 16px;}
				}
			}
		}
		.box2{background-color: #F2F7FF;padding: 64px;
			h3{color: #1F263F;font-size: 36px;font-weight: bold;text-align: center;margin-bottom: 10px;}
			p.name{text-align: center;color: #A4A9B7;font-size: 18px;text-transform: uppercase;margin-bottom: 28px;}
			.cont{padding-left: 100px;padding-right: 18px;display: flex;
				.lfet{display: flex;align-items: center;
					.img1{width: 290px;}
					.img2{width: 254px;margin-left: -110px;}
				}
				.right{position: relative;display: flex;justify-content: space-between;flex-direction: column;
					.item{display: flex;align-items: center;position: relative;
						&.left{left: 107px;}
						.img{width: 64px;margin-right: 26px;}
						.txt{
							h5{color: #333333;font-size: 20px;margin-bottom: 10px;font-weight: bold;}
							p{color: #999999;font-size: 14px;width: 450px;line-height: 22px;}
						}
					}
				}
			}
		}
		.box3{padding-top: 64px;padding-bottom: 70px;
			h3{color: #1F263F;font-size: 36px;font-weight: bold;text-align: center;margin-bottom: 10px;}
			p.name{text-align: center;color: #A4A9B7;font-size: 18px;text-transform: uppercase;margin-bottom: 48px;}
			ul{display: flex;align-items: center;justify-content: space-between;
				li{width: 190px;text-align: center;
					.icon{width: 64px;height: 64px;background: #F5F8F9;border-radius: 32px;margin: auto;
						display: flex;align-items: center;justify-content: space-around;
						i{font-size: 30px;color: #1F263F;}
					}
					h5{margin-top: 24px;text-align: center;color: #1F263F;font-size: 20px;font-weight: bold;}
					p{color: #A4A9B7;font-size: 14px;line-height: 28px;margin-top: 10px;}
				}
			}
		}
		.dex{color: #333;font-size: 16px;text-align: center;
			img{width: 100%;}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/aboutUs/components/firstView.vue